export default __webpack_public_path__ + "static/media/21.72680c2c.png";